import { Fieldset, SimpleGrid, TextInput } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import type { LegacyReportDraftData } from "../../../types/legacyReportReview";

const FIELDS = [
  ["caseNumber", "Printed case number"],
  ["patientNameText", "Printed patient name"],
  ["patientFirstName", "Printed first name"],
  ["patientLastName", "Printed last name"],
  ["dateOfBirth", "Printed date of birth"],
  ["sex", "Printed sex"],
  ["medicalRecordNumber", "Printed medical record number"],
  ["dateCollected", "Printed collection date"],
  ["dateReceived", "Printed received date"],
  ["reportedDateText", "Printed report date and time"],
  ["physicianText", "Printed physician"],
  ["laboratoryText", "Printed laboratory"],
] as const;

export default function LegacyReportHeaderFields({
  form,
  readOnly = false,
}: {
  form: UseFormReturnType<LegacyReportDraftData>;
  readOnly?: boolean;
}) {
  return (
    <Fieldset legend="Historical identity and dates">
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
        {FIELDS.map(([field, label]) => (
          <TextInput
            key={field}
            label={label}
            readOnly={readOnly}
            required={field === "caseNumber"}
            description={
              field === "reportedDateText"
                ? "Keep the printed precision and timezone wording."
                : undefined
            }
            {...form.getInputProps(`header.${field}`)}
          />
        ))}
      </SimpleGrid>
    </Fieldset>
  );
}
